import { css } from "@emotion/css";
import { SVGProps } from "react";

export function Lock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={78}
      height={26}
      fill="none"
      {...props}
    >
      <path
        stroke="#122023"
        strokeOpacity={0.14}
        d="M12 13.5h20M45 13.5h20"
        className={styles.line}
      />
      <mask
        id="a"
        width={24}
        height={24}
        x={27}
        y={-1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path fill="#D9D9D9" d="M27-1h24v24H27z" className={styles.line} />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#B6BABB"
          d="M33 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 31 19V9c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 33 7h1V5c0-1.383.487-2.563 1.462-3.538C36.438.488 37.617 0 39 0s2.563.487 3.538 1.462C43.513 2.438 44 3.617 44 5v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v10c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 45 21H33Zm0-2h12V9H33v10Zm6-3c.55 0 1.02-.196 1.413-.588.391-.391.587-.862.587-1.412 0-.55-.196-1.02-.587-1.412A1.926 1.926 0 0 0 39 12c-.55 0-1.02.196-1.413.588A1.926 1.926 0 0 0 37 14c0 .55.196 1.02.587 1.412.392.392.863.588 1.413.588Zm-3-9h6V5c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 39 2c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 36 5v2Z"
        />
      </g>
    </svg>
  );
}

const styles = {
  line: css({
    stroke: "var(--border-base)",
    strokeOpacity: 1,
  }),
};
